export const USER_API_URL =
  process.env.REACT_APP_USER_API_URL || 'http://localhost:5002/graphql';

export const ADMIN_API_URL =
  process.env.REACT_APP_ADMIN_API_URL || 'http://localhost:5001/graphql';
